module.exports = __webpack_public_path__ + "img/civil_case_part_2_splash.9a0314e6.jpg";